<template>
  <va-card>
    <template slot="header">
      <h1 class="mt-0 mb-0">Store Summaries</h1>
    </template>
    <div class="data-table-infinite-scroll--container" ref="scrollable">
      <va-data-table :fields="fields" :data="storeSummaries" api-mode no-pagination>
        <template slot="marker" slot-scope="props">
          <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
        </template>
      </va-data-table>

      <div class="flex-center ma-3">
        <spring-spinner v-if="loading" :animation-duration="2000" :size="60" :color="$themes.primary" />
      </div>
    </div>
  </va-card>
</template>

<script>
import { SpringSpinner } from 'epic-spinners'
export default {
  components: {
    SpringSpinner,
  },
  props: {
    orders: Array,
    selectedStores: Array,
  },
  data() {
    return {
      storeSummaries: [],
      loading: false,
      offset: 0,
    }
  },
  computed: {
    fields() {
      return [
        {
          name: '__slot:marker',
          width: '30px',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: 'Store Name',
        },
        {
          name: 'numOrders',
          title: 'Number of Orders',
        },
        {
          name: 'totalVal',
          title: 'Total Order Value (USD $)',
        },
        {
          name: 'averageVal',
          title: 'Average Order Value (USD $)',
        },
      ]
    },
  },
  mounted() {
    this.moldData()
  },
  methods: {
    moldData: function () {
      const storeSummaries = {}
      for (let i = 0; i < this.orders.length; i++) {
        if (storeSummaries[this.orders[i].store_id] === undefined) {
          storeSummaries[this.orders[i].store_id] = {
            numOrders: 0,
            totalVal: 0,
            averageVal: 0,
            storeId: this.orders[i].store_id,
          }
        }
        storeSummaries[this.orders[i].store_id].numOrders++
        storeSummaries[this.orders[i].store_id].totalVal += this.orders[i].total_order_value
      }

      const storeNames = this.selectedStores.map((store) => {
        if (storeSummaries[Number(store.id)] === undefined) {
          storeSummaries[Number(store.id)] = {
            storeId: store.id,
            numOrders: 0,
            totalVal: 0,
            averageVal: 0,
          }
        }
        return { id: store.id, title: store.title }
      })

      const storeArray = Object.values(storeSummaries)

      if (storeNames.length <= 0) {
        return // Jump out if there are no selected stores
      }
      for (let i = 0; i < storeArray.length; i++) {
        storeArray[i].name = storeNames.filter((s) => s.id == storeArray[i].storeId)[0].title // eslint-disable-line eqeqeq

        if (storeArray[i].totalVal !== 0) {
          storeArray[i].averageVal = Math.round((storeArray[i].totalVal / storeArray[i].numOrders) * 100) / 100
        }

        storeArray[i].totalVal = Math.round(storeArray[i].totalVal * 100) / 100
      }

      storeArray.sort((a, b) => b.numOrders - a.numOrders)

      this.storeSummaries = storeArray
    },
  },
  watch: {
    orders() {
      this.moldData()
    },
  },
}
</script>

<style lang="scss">
.data-table-infinite-scroll--container {
  height: 300px;
  overflow-y: auto;
}
</style>
